import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=90d5e432&scoped=true&lang=pug&"
import script from "./scene.vue?vue&type=script&lang=js&"
export * from "./scene.vue?vue&type=script&lang=js&"
import style0 from "./scene.vue?vue&type=style&index=0&id=90d5e432&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d5e432",
  null
  
)

export default component.exports